import React from 'react';
import './productMain.style.sass';
import productData from '../../data/products/products.json';
import {AddProduct} from "../../redux/users/users.actions";
import {connect} from 'react-redux';
import {createStructuredSelector} from "reselect";
import {selectProduct} from "../../redux/users/users.selector";
import HeaderPage from '../../assets/image/SingleProductHeader.png';
import {SetProduct} from "../../redux/site/site.actions";
import Products from "../products/products.component";
import SubHeaderComponent from "../../components/subHeader/subHeader.component";


const ProductsMain = ({addProduct, productItem, setProduct, history}) => {
    const HandleClick = (item) => {
        setProduct(item);
    }
    return (
        <div className='productsMain'>
            <SubHeaderComponent imageSrc={HeaderPage} pageName='محصولات زیتونیکس'/>
            <div className='productMain-container'>
                <Products sub={true}/>
            </div>
        </div>
    );
};

const mapDispatchToProps = dispatch =>({
    addProduct: (product) => dispatch(AddProduct(product)),
    setProduct: product => dispatch(SetProduct(product)),
});
const mapStateToProps = createStructuredSelector({
    productItem: selectProduct
})

export default connect(mapStateToProps,mapDispatchToProps)(ProductsMain);